import { Validator } from 'vee-validate';

const validate = {
    custom: {
        transport_type: {
            required: '( ກະລຸນາເລືອກປະເພດການຂົນສົ່ງ... )',
        },
        address_country: {
            required: '( ກະລຸນາເລືອກປະເທດປາຍທາງ... )',
        },
        shipping_rates: {
            required: '( ກະລຸນາປ້ອນລາຄາຂົນສົ່ງ... )',
        },
        volumetric_weight_formula: {
            required: '( ກະລຸນາປ້ອນສູດຄິດໄລ່ນ້ຳໜັກ... )',
        },
        receiver_name: {
            required: '( ກະລຸນາປ້ອນຊື່ຜູ້ຮັບ... )',
        },
        phone: {
            required: '( ກະລຸນາປ້ອນເບີໂທ... )',
        },
        address: {
            required: '( ກະລຸນາປ້ອນທີ່ຢູ່... )',
        },
        address_district: {
            required: '( ກະລຸນາປ້ອນເຂດ/ເມືອງ... )',
        },
    },
};

export const ValidateShipping = (Vue) => {
    Validator.localize('en', validate);
    Vue.$validator.localize('en', validate);
};
